import { DiscoveryApi, IdentityApi } from '@backstage/core-plugin-api';
import { ApplicationDeployApi } from './api.interface';
import CustomError from '../../components/shared/error-handling/error';
import { CreateApplicationPipeline } from './dto/request/create-application-deploy.request';
import { CreateApplicationDeployRoot } from './dto/response/create-application-deploy.response';
import { GetJobLog } from './dto/response/get-job-log.response';
import { GetApplicationDeployRoot } from './dto/response/get-application-deploy.response';
import {ScmAuthApi} from '@backstage/integration-react';

export class ApplicationDeployApiClient implements ApplicationDeployApi {
    discoveryApi: DiscoveryApi;
    identityApi:  IdentityApi;
    scmAuthApi: ScmAuthApi;

    constructor({ discoveryApi, identityApi, scmAuthApi }: { discoveryApi: DiscoveryApi, identityApi: IdentityApi, scmAuthApi: ScmAuthApi }) {
        this.discoveryApi = discoveryApi;
        this.identityApi = identityApi;
        this.scmAuthApi = scmAuthApi;
    }
  
    private async fetch<T = any>(input: string, init?: RequestInit): Promise<T> {
        // As configured previously for the backend proxy
        const proxyUri = `${await this.discoveryApi.getBaseUrl('proxy')}/application/deploy`;
        const gitlabUrl = await this.discoveryApi.getBaseUrl('gitlab');

        const token = (await this.identityApi.getCredentials()).token;
        let userCredentials = (await this.scmAuthApi.getCredentials({ instantPopup: false,  optional: true, url: gitlabUrl, additionalScope: { customScopes: { gitlab: ['api'] } } }));
        if (!userCredentials.token) 
            userCredentials = (await this.scmAuthApi.getCredentials({ instantPopup: false, url: gitlabUrl, additionalScope: { customScopes: { gitlab: ['api'] } } }));

        const headers = {
            ...init?.headers,
            'Authorization': `Bearer ${token}`,
            'User-Authorization': `Bearer ${userCredentials.token}`,
            'Content-Type': 'application/json'
        };
    
        // Create a new init object with merged headers
        const newInit: RequestInit = {
            ...init,
            headers: headers
        };

        const resp = await fetch(`${proxyUri}${input}`, newInit);
        if (!resp.ok) {
            throw new CustomError(`Error ${resp.status}: ${resp.statusText}`, resp.status);
        }
        return await resp.json();
    }

    async getApplicationDeploy (environment: string, system_name: string, application_name: string): Promise<GetApplicationDeployRoot> {
        return await this.fetch<GetApplicationDeployRoot>(`/environment/${environment}/system/${system_name}/application/${application_name}`);
    }

    async getJobLog (environment: string, system_name: string, application_name: string, job_id: number): Promise<GetJobLog> {
        return await this.fetch<GetJobLog>(`/environment/${environment}/system/${system_name}/application/${application_name}/job/${job_id}/log`);
    }

    async createApplicationDeploy (environment: string, system_name: string, body: CreateApplicationPipeline): Promise<CreateApplicationDeployRoot> {
        return await this.fetch<CreateApplicationDeployRoot>(`/environment/${environment}/system/${system_name}/application`, {
            method: 'POST', headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        });
    }
}